<template>
    <div>
        <h4 class="font-weight-bold text-uppercase ml-2 c-orange">Solicitar saque</h4>
            <div class="ml-3">
                <h6 class="mt-3">Saldo disponível: <b-badge variant="secondary">R$ {{formatMoneyUn(realMoney)}}</b-badge></h6>
            </div>
        <div class="container mt-3">
                <b-form-group>
                    <b-form-radio v-model="selected" value="valueIntegral">Valor integral</b-form-radio>
                    <b-form-radio v-model="selected" value="valueSelected">Selecionar valor
                    </b-form-radio>
                </b-form-group>
                <div v-if="selected == 'valueSelected'">
                    <input       
                    type="number"
                    v-model="allowIntegral"
                    placeholder="R$"
                    v-mask="['##.##','###.##', '####.##']"
                    >
                </div>
                <p v-if="selected == 'valueIntegral'">R$ {{formatMoneyUn(realMoney)}}</p>
            <div class="d-flex justify-content-between mt-5">
                <button class="btn btn-success" @click="withdraw()">Solicitar saque</button>
                <button class="btn btn-danger" @click="$bvModal.hide('allowModal')">Cancelar</button>
            </div>
        </div>
    </div>
</template>
<script>
import makeToast from '../../mixins/makeToast';
import { mapState } from "vuex";
export default {
    mixins: [makeToast],
    data() {
        return {
            allowIntegral: false,
            selected: 'valueSelected'
        }
    },

    props: {
        realMoney: {
        type: Number,
        required: false,
        }
    },

    computed: {
    ...mapState(['token', 'dadosUsuario'])
},

    methods: {
        formatMoneyUn(value) {
            var money = parseFloat(value);
            return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
        },
        withdraw() {
            if(this.selected == 'valueSelected' && this.allowIntegral == 0) {
                this.makeToast('Oopss', 'Valor não pode ser igual a nulo!', 'danger');
                return;
            }
            if(this.selected == 'valueSelected' && this.allowIntegral > this.realMoney) {
                this.makeToast('Oopss', 'Valor solicitado não pode ser maior que o saldo!', 'danger');
                return;
            }
            if(this.selected == '') {
                this.makeToast('Oopss', 'Selecione uma opção!', 'danger');
                return;
            }
            const data = {
                'id': this.dadosUsuario.id,
                'value': this.selected == 'all' ? this.realMoney : parseInt(this.allowIntegral),
                'phone': this.dadosUsuario.phone
            }
            this.$store.dispatch('startLoader');
            this.$store.dispatch('balconista/solicitarSaqueBalconista', data)
            .then((resp) => {
                if(resp.status == 200) {
                    this.makeToast('sucesso', 'Solicitação enviada com sucesso!', 'success');
                    this.$bvModal.hide('allowModal');
                } else {
                    this.makeToast('Oopss', 'Erro ao solicitar saque!', 'danger')
                }
            })
            .catch(() => {
                this.makeToast('Oopss', 'Erro ao solicitar saque!', 'danger')
            })
            .finally(() => {
                this.$store.dispatch('endLoader');
                this.$bvModal.hide('allowModal');

            });
        },
    }
}
</script>